import { noop } from '../../../../../lib/utilities';
import React from 'react';
import PropTypes from 'prop-types';
import calculateSetPrice from '../../../helper/calculate_set_price';
import { Product } from './product';

export const Products = ({
  products,
  showDetails,
  currencyIsoCode,
  onShowProductDetailsClick,
  onMatesRatesLearnMoreClick,
  cartProducts,
  shipments,
}) =>
  products.map((product) => (
    <Product
      type={product.type}
      productId={product.id}
      brand={product.brand}
      name={product.model}
      description={product.size}
      buy4pay3={product.buy4pay3 === 1}
      cashback100={product.cashback100 || false}
      quantity={parseInt((product.qty || product.quantity || 1), 10)}
      pricePerItem={product.price}
      setPrice={calculateSetPrice(product.qty, product.price, product)}
      currencyIsoCode={currencyIsoCode}
      showDetails={showDetails}
      onShowProductDetailsClick={onShowProductDetailsClick}
      onMatesRatesLearnMoreClick={onMatesRatesLearnMoreClick}
      cartProducts={cartProducts}
      key={product.brand + product.model + '_' + product.id}
      clearance={product.clearance}
      lightContentAvailable={product.lightContentAvailable}
      cartProductType={product.cartProductType}
      productLinksTitles={product.productLinksTitles}
      isFittingAvailable={product.isFittingAvailable}
      shipments={shipments}
      productUrl={product.url}
    />
  ));

Products.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  showDetails: PropTypes.bool.isRequired,
  currencyIsoCode: PropTypes.string.isRequired,
  onShowProductDetailsClick: PropTypes.func,
  onMatesRatesLearnMoreClick: PropTypes.func,
  cartProducts: PropTypes.arrayOf(PropTypes.object),
};

Products.defaultProps = {
  onShowProductDetailsClick: noop,
  onMatesRatesLearnMoreClick: noop,
  cartProducts: [],
};
